// Ubicación sugerida en tu proyecto: src/components/hooks/useSubcategorias.ts
// Ajusta el import de "supabase" para que coincida con el que usa
// useCategoriasEmpresa.ts (probablemente @/lib/supabase o similar).

import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabaseClient';

export interface Subcategoria {
  id_subcategoria: string;
  id_categoria: string;
  subcategoria: string;
}

export function useSubcategorias(idCategoria: string | null) {
  const [subcategorias, setSubcategorias] = useState<Subcategoria[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!idCategoria) {
      setSubcategorias([]);
      return;
    }

    let activo = true;
    setLoading(true);

    supabase
      .from('vista_cb_subcategorias')
      .select('id_subcategoria, id_categoria, subcategoria')
      .eq('id_categoria', idCategoria)
      .order('subcategoria')
      .then(({ data, error }) => {
        if (!activo) return;
        if (error) {
          console.error('Error al cargar subcategorías:', error);
          setSubcategorias([]);
        } else {
          setSubcategorias(data ?? []);
        }
        setLoading(false);
      });

    return () => {
      activo = false;
    };
  }, [idCategoria]);

  return { subcategorias, loading };
}